<template>
  <div class="main-content-container container-fluid px-4">
    <d-alert class="alert-royal-blue" :show="show_alert" theme="danger" ref="dalert" style="position:sticky;top:0;left:0;z-index:10000;" dismissible >
      <i class="fa fa-info mx-2"></i>
      <span id="warning">{{ error_msg }}</span> 
    </d-alert>
    <!-- Page Header -->
    <div class="page-header row no-gutters py-4">
      <div class="col-12 col-sm-4 text-center text-sm-left mb-0">
        <span class="text-uppercase page-subtitle">List</span>
        <h3 class="page-title">Ulang Tahun Donatur</h3>
      </div>
    </div>
    <div class="row">
      <div class="col">
        <div class="card card-small mb-4">
          <div class="card-header border-bottom">
             <!--d-button type="button" :disabled="loading" class="btn-accent" @click="add_new" data-toggle="tooltip" data-placement="top" title="Add New" ><i class="material-icons">note_add</i> Tambah Baru</d-button>
              &nbsp;
              <button type="button" class="btn-primary btn-sm" @click="xls()" style="padding:0.15rem 0.5rem !important">List Ulang Tahun</button-->
          </div>
          <div class="card-body p-0 pb-3 text-center" style="overflow-x:scroll">
            <d-row style="margin:auto">
            <d-col md="4"  class="form-group" style="text-align:left">
              Menampilkan 
              <select v-model="ipp" >
                <option value=5 selected>5 item</option>
                <option value=10>10 item</option>
                <option value=15>15 item</option>
                <option value=20>20 item</option>
                <option value=0>Semua</option>
              </select>          
              &nbsp;&nbsp;
            </d-col>
            <d-col md="4"  class="form-group">
            </d-col>
            <d-col md="4"  class="form-group">
              <d-form-input type="text" id="feInputAddress" placeholder="Cari" v-model.trim="search" />
            </d-col>
            </d-row>
            <d-row>
            <v-gallery :images="images" :index="index" @close="index = null"></v-gallery>
            </d-row>
        <b-table
            :data="isEmpty ? [] : data"
            :loading="loading"
            :mobile-cards="hasMobileCards"
            paginated
            backend-pagination
            :total="total"
            :per-page="perPage"
            :current-page="page"
            @page-change="onPageChange"
            :sort-icon="sortIcon"
            :sort-icon-size="sortIconSize"
            aria-next-label="Next page"
            aria-previous-label="Previous page"
            aria-page-label="Page"
            aria-current-label="Current page"

            backend-sorting
            :default-sort-direction="defaultSortOrder"
            :default-sort="[sortField, sortOrder]"
            @sort="onSort"            
            >

            <template slot-scope="props">
                <b-table-column field="id" label="Id" >
                    <span class="tag is-success">
                    {{ props.row.id }}
                    </span>
                    <button type="button" class="btn-primary btn-sm" @click="open_wa(props.row)" style="padding:0.15rem 0.5rem !important">WA</button>
                </b-table-column>
                <b-table-column field="gender" label="Gender" >
                    {{ props.row.gender==1 ? "Bpk":"Ibu" }}
                </b-table-column>
                <b-table-column field="fullname" label="Nama Lengkap" >
                    {{ props.row.fullname }}
                </b-table-column>
                <b-table-column field="email" label="Email" >
                    {{ props.row.email }}
                </b-table-column>
                <b-table-column field="mobile_phone" label="HP" style="text-align:right" >
                    {{ props.row.mobile_phone }}
                </b-table-column>
                <b-table-column field="dob" label="Tgl Lahir" >
                    {{ props.row.dob }}
                </b-table-column>
                <b-table-column field="age" label="Umur" >
                    {{ props.row.age }}
                </b-table-column>
                <b-table-column field="category" label="Kategori" >
                    {{ find_category(props.row.category) }}
                </b-table-column>
            </template>

            <template slot="empty">
                <section class="section">
                    <div class="content has-text-grey has-text-centered">
                        <p>
                            <b-icon
                                icon="emoticon-sad"
                                size="is-large">
                            </b-icon>
                        </p>
                        <p>Tidak ada data.</p>
                    </div>
                </section>
            </template>
        </b-table>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import env from '../env.vue';
import FileSaver from 'file-saver'

    export default {
        data() {
            return {
                show_alert:false,
                data:[],
                list:[],
                error_msg:'',
                index:0,
                images:[],
                isEmpty: false,
                isHoverable: true,
                loading: false,
                hasMobileCards: true,
                sortField:'id',
                sortOrder:'asc',
                sortIcon:'arrow-up',
                sortIconSize:'is-small',
                sort:'name',
                defaultSortOrder:'asc',
                page:1,
                perPage:5,
                total:2,
                filename:'',
                ipp:5,
                search:'',
                categories:env.categories,
            }
        },
        watch:{
          ipp(){
           if (this.ipp>0) this.perPage=this.ipp*1
           else this.perPage=this.total*1
           this.update_data();
          },
          search(){
           if(parseInt(this.search)>0||this.search.length>3||!this.search.length)this.update_data()
          },
        },
        methods:{
          find_category(cat){
            let resp= this.categories.filter( c=>c.value==cat ) 
            return resp[0].text;
          },
          add_new(){
            this.$router.push({name:'donator-form',params:{id:0},query:{id:0}});
          },
          open_wa(obj){
/*
            let strm="Selamat ulang tahun "+(obj.gender==1?'Bpk':'Ibu')+' '+obj.fullname;
            window.open("https://wa.me/"+obj.mobile_phone+"?text="+encodeURI(strm))
*/
           let res='';
           do {
              res=confirm('Pesan Selamat Ulang tahun WA otomatis dikirim per menit,\napakah mau mengirim pesan WA sekali lagi ?');
           } while( res==='')
           if (!res)return;
           this.loading=true;           
           this.axios.post( env.server+'/donator/resend-birthday-card/'+obj.id,{
           }).then(
             resp=>{
                this.loading=false;           
           })
          },
          add_donation(id){
            this.$router.push({name:'donation-form',params:{id:id},query:{id:id}});
          },
          save_state(){
            var arr={
              page:this.page,
              perPage:this.perPage,
              total:this.total,
              ipp:this.ipp,
              search:this.search,
              sortField:this.sortField,
              sortOrder:this.sortOrder,
            };
            this.$store.commit('list',arr);
          },
          load_state(){
            var arr=this.$store.state.list;
            if ( arr==null ) return;
            this.page=arr.page;
            this.perPage=arr.ipp>0 ? arr.perPage : arr.total;
            this.total=arr.total;
            this.ipp=arr.ipp;
            this.search=arr.search;
            this.sortField=arr.sortField;
            this.sortOrder=arr.sortOrder;
          },
          onPageChange(page){
           this.page=page;
           this.update_data();           
          },
          onSort(field,order){
           if ( !this.loading ){           
            this.sortField=field;
            this.sortOrder=order;
            this.update_data();
           }
          },
          pop_alert(msg){
            if (msg==undefined) return;
            this.$refs.dalert.dismissed=false;
            this.show_alert=5;
            this.error_msg=msg;
          },
          update_data(){
           this.loading=true;           
           this.save_state();
           this.axios.post( env.server+'/birthday-list',{
             start: this.page,
             length: this.perPage>0 ? this.perPage: this.total,
             sort: this.sortField,
             sort_order: this.sortOrder,
             scfilter: this.search,
             location: '',
             church: '',
             category: '',
             dtype: '',
             minage: '',
             maxage: '',
             gender: '',
           }).then(
             resp=>{
               resp.data=JSON.parse(resp.data);
               this.loading=false;
               this.data=resp.data.data.items;
               this.total=resp.data.data.total_results;
               for (var i=0; i<this.data.length; i++ ){
                 this.data[i].idx=i;
                 let tmp=[];
                 tmp=this.data[i].dob.split('-');
                 this.data[i].dob=tmp[2]+'-'+tmp[1]+'-'+tmp[0];
               }
             }
           );
          },
        },
        mounted(){           
          var dt = new Date();
          this.ddate=dt.getFullYear()+'-'+(dt.getMonth()+1)+'-'+dt.getDate();
          this.load_state();
          this.update_data();
        },
    }
</script>
